module.exports = __webpack_public_path__ + "static/media/add.6a65d2f8.svg";